import { useState } from 'react'
import { useEffectOnce } from 'react-use'
import { ActivityState } from '@/api/models/activity'
import { LearnerObjectiveAccessFullModel } from '@/api/models/aggregate'
import { useCatalogCourseNavigate } from '@/hooks/useCatalogCourseNavigate'
import { useCourseNavigate } from '@/hooks/useCourseNavigate'
import { useIsCatalogCourse } from '@/hooks/useIsCatalogCourse'

export const useShouldRedirectToCatalogOrEnrolledCourse = (aggregate: LearnerObjectiveAccessFullModel | undefined) => {
  const isCatalogPage = useIsCatalogCourse()
  const { navigateToCourse: navigateToCatalogCourse } = useCatalogCourseNavigate()
  const { navigateToCourse } = useCourseNavigate()

  const [redirected, setRedirected] = useState(false)

  useEffectOnce(() => {
    // prevent multiple redirections
    if (redirected || !aggregate) return

    const isMandatory = !!aggregate?.isMandatory
    const isSelfEnrolled = !!aggregate?.objectiveWorkflowAggregate?.isSelfEnrolled
    const hasWorkflow = !!aggregate?.objectiveWorkflowAggregate?.lastObjectiveWorkflow
    const isArchived = aggregate?.objective?.activity?.state === ActivityState.archived

    // if it is not mandatory, it means it should be shown under /catalog
    if (!isMandatory && !isCatalogPage && !isSelfEnrolled && !hasWorkflow && !isArchived) {
      navigateToCatalogCourse(aggregate?.objective?.id)
      setRedirected(true)
      return
    }

    if (isCatalogPage && (hasWorkflow || isSelfEnrolled)) {
      navigateToCourse(aggregate?.objective?.id)
      setRedirected(true)
    }
  })
}
